import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { GlobalLoadingComponent, SidebarComponent } from '@core/component';

@Component({
  imports: [RouterOutlet, CommonModule, SidebarComponent, GlobalLoadingComponent],
  templateUrl: './main.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  styleUrl: './main.component.scss',
})
export class MainComponent {
  isSidebarCollapsed = false;

  onSidebarToggle() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }
}
